import { EMPTY_STRING } from '../../../../constants/common'

export const PROFILE_PARTNER_INFO_INHABITANT_DATA = {
  email: 'richard.gray@example.com',
  first_name: 'Richard',
  full_name: 'Richard Gray',
  last_name: 'Gray',
  middle_name: 'Edward',
  notes: EMPTY_STRING,
  phone: '+4366412365412',
  salutation: { id: 180, salutation: 'Sehr geehrte Damen und Herren' },
  title: 'Director',
}
